import React, { useEffect, useState } from 'react';
import { matchPath, useLocation, useNavigate, useParams } from 'react-router-dom';
import { User, useUserStore } from "@/stores/user";
import { Project, ProjectCategory, useProjectStore } from "@/stores/project";
import { useLoadingStore } from '@/stores/loading'
import qs from 'qs'
import { getProjects } from "@/api/projects";
import {axios} from '@/lib/axios'
import * as Config from '@/config'
import { FaBars } from 'react-icons/fa';
import Cookies from 'js-cookie';

export default function Header() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const query = qs.parse(search.substring(1));

  const setLoading = useLoadingStore(state => state.setLoading);
  const user = useUserStore(state => state.user);
  const [
    isMenuOpen,
    setIsMenuOpen
  ] = useProjectStore(state => [
    state.isMenuOpen,
    state.setIsMenuOpen,
  ]);
  const [isCookieOpen, setIsCookieOpen] = useState(Cookies.get('sideMenuOpen') === 'true');


  // storeではエラー
  useEffect(() => {
    if (isCookieOpen) {
      setIsMenuOpen(isCookieOpen);
    }
  }, [isCookieOpen]);

  const onClickUser = () => {
    if (pathname !== '/password_change') {
      navigate('/password_change');
    }
  }

  const toggleMenu = () => {
    const newState = !isMenuOpen;
    setIsMenuOpen(newState);
    Cookies.set('sideMenuOpen', String(newState), { expires: 365 });
  };

  return (
    <header>
      <div className='header-left-content'>
        {user && user.is_changed_password === 1 && pathname !== "/login" && 
          <div className="hamburger-icon" onClick={toggleMenu}>
            <FaBars />
          </div>
        }
        {Config.HEADER_ENV !== "" && <span className="uk-margin-small-left env-label">{Config.HEADER_ENV}</span>}
      </div>
      {user?.is_changed_password === 1 &&
          <div>
              <ul className="header-right-item">
                  <li className="header-logintime">最終ログイン日時：{user.logged_in_date}</li>
                  <li className="header-username">
                      <a onClick={onClickUser}>ユーザ名：{user.last_name + user.first_name}</a>
                  </li>
              </ul>
          </div>
      }
    </header>
  );
}